 'use strict';

angular.module('mediacloudApp')
    .factory('notificationInterceptor', function ($q, AlertService) {
        return {
            response: function(response) {
                var alertKey = response.headers('X-mediacloudApp-alert');
                if (angular.isString(alertKey)) {
                    AlertService.success(alertKey, { param : response.headers('X-mediacloudApp-params')});
                }
                return response;
            }
        };
    });
